import React from 'react';
import PaymentProviderPage from './components/payment-provider-page';

const Ameriabank = () => {
    return (
        <PaymentProviderPage
            provider="ameriabank"
            title="Ameriabank"
            fields={[
                { name: 'client_id', label: 'Client ID' },
                { name: 'username', label: 'Username' },
                { name: 'password', label: 'Password', type: 'password' },
            ]}
        />
    );
};

export default Ameriabank;
